// /mail/connected — לאן ה-callback של גוגל מחזיר (20 §1.2). בחלון הקופץ (popup=1): מודיע ל-drawer "חיבור Gmail" שפתח אותו
// (BroadcastChannel + postMessage ל-opener באותו origin) ונסגר. באותה לשונית (החלון נחסם): חוזר לנתיב שממנו יצאו עם
// ?mail=…&mailResult=connected|<קוד> — ה-drawer נפתח שם עם התוצאה. בלי session ובלי Layout: רק הודעה קצרה.
import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router';
import { MAIL_MSG, MAIL_PARAM, MAIL_RESULT_PARAM, notifyOpener, parseCaps, type MailMsg } from '../lib/mailConnect.ts';
import { safeReturn } from '../lib/safeReturn.ts';
import { T } from '../lib/strings.ts';
import { IconAlert, IconCheck } from '../components/brand/icons.tsx';

export function MailConnectedPage() {
  const [sp] = useSearchParams();
  const caps = parseCaps(sp.get('connected'));
  const error = sp.get('error');
  const ok = !error && caps.length > 0;
  const popup = sp.get('popup') === '1';
  const msg: MailMsg = ok ? { type: MAIL_MSG, ok: true, caps } : { type: MAIL_MSG, ok: false, error: error ?? 'oauth_failed' };

  useEffect(() => {
    if (!popup) return;
    notifyOpener(msg);
    const t = setTimeout(() => window.close(), 400);
    return () => clearTimeout(t);
  }, []);

  if (!popup) {
    const back = new URL(safeReturn(sp.get('return')), 'https://aibify.invalid');
    const n = new URLSearchParams(back.search);
    if (!n.get(MAIL_PARAM)) n.set(MAIL_PARAM, ok ? caps.join(',') : 'manage');
    n.set(MAIL_RESULT_PARAM, msg.ok ? 'connected' : msg.error);
    return <Navigate to={`${back.pathname}?${n}`} replace />;
  }

  return (
    <main className="grid min-h-(--ab-screen) place-items-center bg-background p-6 text-center" data-testid="mail-callback" data-ok={ok}>
      <div className="flex max-w-xs flex-col items-center gap-3">
        <span aria-hidden="true" className={ok ? 'grid size-14 place-items-center rounded-circle bg-ok/15 text-ok' : 'grid size-14 place-items-center rounded-circle bg-error/10 text-error'}>
          {ok ? <IconCheck size={30} /> : <IconAlert size={28} />}
        </span>
        <p className="m-0 font-semibold">{ok ? T.mail.popupDone : T.mail.popupError}</p>
      </div>
    </main>
  );
}
